var _circle, _circle2, _g, _circle3, _path, _circle4, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#FDB022"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1478_17853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#FDB022"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1478_17853)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1478_17853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9H-4.125L5.625 22.5L20.625 18L22.5 9Z",
    fill: "#F79009"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 6.75,
    fill: "#F79009"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.48428 4.37529C8.44776 4.04781 8.6841 3.74916 9.0136 3.75001C9.97496 3.75249 10.9214 4.01907 11.7471 4.5261C12.5729 5.03314 13.2388 5.75659 13.6759 6.61282C13.8257 6.9063 13.6663 7.25218 13.3577 7.36776V7.36776C13.0492 7.48333 12.709 7.32397 12.5495 7.03567C12.2122 6.4263 11.722 5.91088 11.1228 5.54295C10.5235 5.17501 9.84209 4.97094 9.14607 4.94586C8.81678 4.934 8.52079 4.70276 8.48428 4.37529V4.37529Z",
    fill: "#FFFCF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1478_17853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 14,
    height: 14
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 6.75,
    fill: "#FDB022"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1478_17853)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9989 6.75C7.75565 6.75 6.74525 7.75475 6.74732 8.99566C6.74732 10.2366 7.75565 11.2413 8.9989 11.2413C10.2422 11.2413 11.2526 10.2366 11.2526 8.99566C11.2526 7.75475 10.2442 6.75 8.9989 6.75V6.75ZM8.9989 11.84C8.67249 11.8421 8.31282 11.8131 7.90742 11.7385C7.10492 11.5894 6.62258 11.1709 5.6496 11.3615C3.50822 11.782 1.67037 17.9141 4.29201 17.999C5.69534 18.0446 6.54982 16.4598 7.61012 16.0434C7.89494 15.9315 8.46043 15.8777 8.9989 15.8756C9.53944 15.8777 10.1029 15.9315 10.3898 16.0434C11.4501 16.4598 12.3045 18.0446 13.7079 17.999C16.3295 17.9141 14.4917 11.782 12.3503 11.3615C11.3773 11.1688 10.8929 11.5873 10.0925 11.7385C9.68705 11.8131 9.32738 11.8421 8.9989 11.84",
    fill: "url(#paint0_linear_1478_17853)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1478_17853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 7.93125L5.54861 7.8422L5.61806 7.5L5.67187 7.82813L5.8125 7.875L5.67187 7.96875L5.61806 8.25L5.57812 7.96875L5.4375 7.93125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1478_17853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.1125L3.97222 5.9344L4.11111 5.25L4.21875 5.90625L4.5 6L4.21875 6.1875L4.11111 6.75L4.03125 6.1875L3.75 6.1125Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1478_17853",
    x: -5.63761,
    y: 7.48739,
    width: 29.6502,
    height: 16.5252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.756303,
    result: "effect1_foregroundBlur_1478_17853"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1478_17853",
    x: 5.36187,
    y: 7.42437,
    width: 0.526261,
    height: 0.901261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0378151,
    result: "effect1_foregroundBlur_1478_17853"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1478_17853",
    x: 3.67437,
    y: 5.17437,
    width: 0.901261,
    height: 1.65126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0378151,
    result: "effect1_foregroundBlur_1478_17853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1478_17853",
    x1: 8.99994,
    y1: 6.75,
    x2: 8.99994,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455074,
    stopColor: "white",
    stopOpacity: 0.561695
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoin);
export default __webpack_public_path__ + "static/media/icon-coin.6651642ee10a5a7312b0cf674fd426019659ffcd8cf8a67d6a8f404de610edc1.svg";
export { ForwardRef as ReactComponent };